import React from 'react';

function Icon(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14" fill="none" viewBox="0 0 16 14">
      <path
        fill={props.fill || '#1D252D'}
        d="M.54 7.46v1.689a3.18 3.18 0 001.597 2.774l1.998 1.128c.77.415 1.605.635 2.442.635h3.861c2.77 0 5.021-2.324 5.021-5.18v-3.31c0-1.436-1.116-2.61-2.506-2.66a2.592 2.592 0 00-2.031-1.009h-.485c-.127 0-.254.01-.38.03A2.533 2.533 0 008.5 1.022l-1.044.22C6.699.466 6.859.221 5.47.221c-1.452 0-2.64 1.162-2.64 2.59v1.151L1.697 4.984C.982 5.61.54 6.5.54 7.46zm1.718 0c0-.444.189-.856.519-1.13l.626-.565v1.59c0 .316.29.575.572.575a.597.597 0 00.573-.575V2.81c0-.476.386-.863.827-.863.473 0 .859.387.859.863v.155c0 .345.284.577.578.577a.57.57 0 00.527-.366c.08-.038.258-.427.644-.427h.485c.75 0 .641.705 1.226.705.294 0 .352-.201.711-.201h.485c.914 0 .653 1.015 1.383 1.015h.017l.571-.008c.486 0 .881.42.881.935v3.31c0 1.904-1.482 3.453-3.303 3.453H6.577a3.209 3.209 0 01-1.57-.414l-1.996-1.127a1.45 1.45 0 01-.721-1.27V7.46h-.032z"
      ></path>
    </svg>
  );
}

export default Icon;
